import React from "react";

export const Logo = ({ className = "", showWord = true }) => (
  <a href="#top" data-testid="brand-logo" className={`inline-flex items-center gap-2.5 group ${className}`}>
    <span className="relative inline-flex h-9 w-9 items-center justify-center">
      <span className="absolute inset-0 rounded-full bg-emerald-400/10 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <img
        src="/logo.png"
        alt="healthIRL"
        className="relative h-9 w-9 object-contain transition-transform duration-500 group-hover:scale-105"
        draggable="false"
      />
    </span>
    {showWord && (
      <span className="font-heading text-[17px] tracking-tight font-medium text-white">
        health<span className="text-emerald-400">IRL</span>
      </span>
    )}
  </a>
);

export default Logo;
